export default "__VITE_PUBLIC_ASSET__66e4d851__"